
<!-- Template -->
<template>
    <div class="document-title">
                        <form class="filter">
                            <div class="row">
                                
                                <div class="col-sm-12 col-md-5">
                                    <div class="form-group">
                                        <select v-model="search.parent" @change="prep_sub_categories(search.parent)" class="search-select form-control" title="Location">
                                            <option :value="undefined">What do you want to find today?</option>    
                                            <option v-for="cc in cnproParentCategories" :value="cc.cnpro_parent_category_id" :key="cc.cnpro_parent_category_id">{{cc.cnpro_parent_category_name}}</option>
                                            <option value="business-search">Businesses</option>
                                        </select>
                                    </div><!-- /.form-group -->
                                </div><!-- /.col-* -->

                                <div class="col-sm-12 col-md-5">
                                    <div class="form-group">
                                        <select v-if="search.type != 'business-search'" v-model="search.area" @change="prep_search(search.area)" class="search-select form-control" title="Location">
                                            <option :value="undefined">Which of these services in particular</option>
                                            <option v-for="cc in sub_categories" :value="cc.cnpro_category_name" :key="cc.cnnpro_category_name">{{cc.cnpro_category_name}}</option>
                                        </select>
                                        <select v-else v-model="search.area" @change="prep_search(search.area)" class="search-select form-control" title="Location">
                                            <option :value="undefined">Which of these services in particular</option>
                                            <option v-for="cc in sub_categories" :value="cc.business_category_name" :key="cc.cnnpro_category_name">{{cc.business_category_name}}</option>
                                        </select>
                                    </div><!-- /.form-group -->
                                </div><!-- /.col-* -->

                                <div class="col-sm-2">
                                    <button style="width: 100%;"  type="button" @click="doSearch" class="btn btn-primary">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div><!-- /.col-* -->
                            </div><!-- /.row -->
                        </form>
                    </div><!-- /.document-title -->
</template>

<!-- Script -->
<script>
import services from '../services/service'; // Service Class
let service = new services();

export default {
  name: "SearchBar",
  data() {
      return {
          search: {},
          cnproParentCategories:{},
          sub_categories: {}
      }
  },
  methods: {
    /* pre searchers */
    getCnproParentCategories() {
        service.getCnproParentCategories(this).then(data => {
            if(data.body.status == 200) {
                this.cnproParentCategories = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    //cnpro sub categories
    getCnproSubCategories(parent){
        service.getCnproCategories(this,parent).then(data => {
            if(data.body.status == 200) {
                this.sub_categories = data.body.data;
               // document.getElementById("loader").style.visibility = "hidden";
            }
        }).catch((err) => {
            if(err) {
                //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    //businesses
    getBusinessCategories() {
        service.getBusinessCategories(this).then(data => {
            if(data.body.status == 200) {
                this.sub_categories = data.body.data;
            }
        }).catch((err) => {
            if(err) {
               // toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    prep_sub_categories(parent){
        if(parent == "business-search"){
            this.search.type = 'business-search';
            this.getBusinessCategories()
        }
        else{
            this.search.type = 'cnpro-search';
            this.getCnproSubCategories(parent)
        }
    },
    prep_search(keywords){
        this.search.keywords = keywords
        this.search.city = 'Abuja'
    },
    /* pre searchers */
        doSearch(){
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            }

            let navi = this.$router;

            if(credentials.search_type != null || credentials.search_keywords != null) {
                //navi.push(this.search.type+'?context='+this.search.keywords+'&city='+this.search.city); //having issues with cnpro-seach page
                location.replace(this.search.type+'?context='+this.search.keywords+'&city='+this.search.city);
                
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        
    },
    },
    created: function(){
        this.getCnproParentCategories();
    }
}
</script>




// WEBPACK FOOTER //
// SearchBar.vue?2646fc5e